export { default as FormControlLabel } from './FormControlLabel';
